module.exports = __webpack_public_path__ + "static/media/btn-program-carousel-right.da846f13.svg";